import useUserPreferences, { UserPreferenceKeys, UserPreferenceKeyTypes } from './useUserPreferences'

export type UseDefaultStoresReturnType = {
  initialized: boolean,
  defaultStoreIds?: UserPreferenceKeyTypes[UserPreferenceKeys.FilterStoreIds],
  save: ( value: number[] ) => Promise<void>,
}

export default function useDefaultStoreIds() {
	const { initialized, userPreferences, saveUserPreference } = useUserPreferences()

	return {
		initialized,
		defaultStoreIds: userPreferences[ UserPreferenceKeys.FilterStoreIds ],
		save: async( value: number[] | string[] ) => {
			await saveUserPreference( UserPreferenceKeys.FilterStoreIds, value )
		},
	}
}
